export const FEATURE_NAME = '@zerops/zerops/core/integration-token-delegation-base';

// Cache tag for a single token's delegation list (scoped, per-token). The global
// (client-wide) list — used for the token-list badges — stays under the default
// tag. Both the scoped-load effect and the edit dialog use this helper so they
// read and write the same list key.
export const delegationTokenTag = (tokenId: string) => `${FEATURE_NAME}::${tokenId}`;
